import toastr from 'lib/toastr';
import {checkIsIframe} from "../utils/utils";
import {orDefault} from "../utils/var";

const t = checkIsIframe() ? window.top.toastr : toastr;

const MSG_ERROR = 'Ошибка';
const MSG_ERROR_XHR = 'Не удалось выполнить запрос';

export class Notifier {
	static error(message = null, title = null, options = null) {
		// Extend timeout for errors to 10 seconds by default
		const timeOut = options ? orDefault(options.timeOut, 10000) : 10000;
		t.error(orDefault(message, MSG_ERROR), title, { timeOut, ...options });
	}

	static errorXHR(jqXHR, textStatus, errorThrown) {
		if(textStatus != 'abort') {
			Notifier.error(MSG_ERROR_XHR);
		}
	}

	static info(message, title = null, options = null) {
		t.info(message, title, {...options});
	}

	static success(message, title = null, options = null) {
		t.success(message, title, {...options});
	}

	static warning(message, title = null, options = null) {
		t.warning(message, title, {...options});
	}
}



// WEBPACK FOOTER //
// ./core/widgets/notifier.js